import * as Action from '../action';

export default (state = {}, action) => {
  switch (action.type) {
    case Action.ADD_FEEDER_SERVICE_ORDER_HISTORIES:
      return { ...action.feederServiceOrderHistories };
    default: return state;
  }
};
